import DatabaseIcon from '@databases/icons/DatabaseIcon';
import {
  type BasicDatabase,
  type BrokenDatabase,
  type ShallowDatabase
} from '@databases/types/database';
import { formatDistance } from 'date-fns';
import React, { type FunctionComponent } from 'react';

import {
  DatabaseOptionContainer,
  DatabaseOptionContentContainer,
  DatabaseOptionIcon,
  DatabaseOptionInfoContainer,
  DatabaseOptionTitle
} from './databasePicker.styles';

type Option = ShallowDatabase | BasicDatabase | BrokenDatabase;

const calculateTimeAgo = (previousDate: string | undefined) => {
  if (!previousDate) {
    return null;
  }

  const now = new Date();
  const previous = new Date(previousDate);

  if (isNaN(previous.getTime())) {
    return null;
  }

  return formatDistance(previous, now, { addSuffix: true });
};

export interface DatabasePickerOptionProps {
  value: Option;
}

const DatabasePickerOption: FunctionComponent<DatabasePickerOptionProps> = ({
  value
}) => {
  const timeAgo = calculateTimeAgo(value.lastUpdatedDate);

  return (
    <DatabaseOptionContainer>
      <DatabaseOptionIcon>
        <DatabaseIcon label="" />
      </DatabaseOptionIcon>
      <DatabaseOptionContentContainer>
        <DatabaseOptionTitle>{value.name}</DatabaseOptionTitle>
        <DatabaseOptionInfoContainer>
          {/* eslint-disable-next-line @atlaskit/design-system/use-primitives-text */}
          <span>{value.space.name}</span>
          {timeAgo && (
            <>
              {/* eslint-disable-next-line formatjs/no-literal-string-in-jsx, @atlaskit/design-system/use-primitives-text */}
              <span>•</span>
              {/* eslint-disable-next-line @atlaskit/design-system/use-primitives-text */}
              <span>{timeAgo}</span>
            </>
          )}
        </DatabaseOptionInfoContainer>
      </DatabaseOptionContentContainer>
    </DatabaseOptionContainer>
  );
};

export default DatabasePickerOption;
